import { Component, OnInit } from '@angular/core';
import { MyserviceService } from '../myservice.service';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { MessageService, ConfirmationService } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-trading-partner-details',
  templateUrl: './trading-partner-details.component.html',
  styleUrls: ['./trading-partner-details.component.css'],
  providers: [MessageService, ConfirmationService],
})
export class TradingPartnerDetailsComponent implements OnInit {
  tradingPartnerSetupForm: any;
  loader: boolean;
  enableForm: boolean = true;
  enableCSVFile: boolean = false;
  partnerType = 'Form'
  directionsList: any = []
  partnerList: any = []
  streamList: any = []
  divisionList = []
  flowTypeList: any = []
  rehlkoIsaIdList: any = [];
  rehlkoGsList: any = [];
  deliveryTypeList: any = [];
  partnerDetails: any;

  constructor(private fb: FormBuilder, public localstorage: LocalStorageService, private http: HttpClient, private messageService: MessageService, public session: SessionStorageService,
    public datepipe: DatePipe, private service: MyserviceService, private confirmationService: ConfirmationService) { }
  ngOnInit() {

  
    this.tradingPartnerSetupForm = this.fb.group({
      direction: new FormControl("", Validators.required),
      divName: new FormControl("", Validators.required),
      stream: new FormControl("", Validators.required),
      flowType: new FormControl("", Validators.required),
      rehlkoSAPID: new FormControl("", Validators.required),
      rehlkoISAID: new FormControl("", Validators.required),
      rehlkoGS: new FormControl("", Validators.required),
      partnerName: new FormControl("", Validators.required),
      partnerISAQualify: new FormControl("", Validators.required),
      partnerISAId: new FormControl("", Validators.required),
      partnerGS: new FormControl("", Validators.required),
      partnerST: new FormControl("", Validators.required),
      gsFunctionalCode: new FormControl("", Validators.required),
      mapName: new FormControl("", Validators.required),
      deliveryType: new FormControl("", Validators.required),
      acceptorLookupAlias: new FormControl("", Validators.required),
    });
    this.dropdownsData();
    this.service.getPartnerInfo().subscribe(data => {
      if (data) {
        console.log('Received Partner Info:', data);
        this.partnerDetails = data;
        this.bindthePartnerInfo(data);
      }
    });
  }
  bindthePartnerInfo(object) {
    this.tradingPartnerSetupForm.patchValue({
      direction: object.TC_DIRECTION,
      divName: object.TC_DivisionName,
      stream: object.TC_Stream,
      flowType: object.FlowType,
      rehlkoSAPID: object.TC_SAP_ID,
      rehlkoISAID: object.TC_REHLKO_ISA_ID,
      rehlkoGS: object.TC_REHLKO_GS,
      partnerName: object.TC_PartnerName,
      partnerISAQualify: object.TC_PARTNER_ISA_ID_QUALF,
      partnerISAId: object.TC_PARTNER_ISA_ID,
      partnerGS: object.TC_PARTNER_GS,
      partnerST: object.TC_PARTNER_ISA_ID, // If partnerST means ST/ISA ID again, else change key
      gsFunctionalCode: object.TC_GS_FunctionalCode,
      mapName: object.TC_MapName,
      deliveryType: object.TC_DeliveryType,
      acceptorLookupAlias: object.TC_SAP_ID // assuming it's same — change if needed
    });
  }
  dropdownsData() {
    this.getDirection();
    this.getStream();
    this.getDivName();
    this.getFlowType();
    this.getRehlkoIsaId();
    this.getRehlkoGs();
    this.getDeliveryType();
  }
  addPartnerType(type) {
    if (type == 'Form') {
      this.enableForm = true
      this.enableCSVFile = false
    }
    else {
      this.enableForm = false
      this.enableCSVFile = true
    }
  }
  getDirection() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    // this.loader = true;
    this.http
      .get(environment.apiUrl + "/tradingPartner/directions", {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        this.loader = false
        const result = JSON.parse(data).map(item => ({ label: item, value: item }));
        this.directionsList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, typeof data, result, "direction dataa===========");
      })
  }

  getStream() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    // this.loader = true;
    this.http
      .get(environment.apiUrl + "/tradingPartner/stream", {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        this.loader = false
        const result = JSON.parse(data).map(item => ({ label: item, value: item }));
        this.streamList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, typeof data, "getStream dataa===========");
      })
  }

  getDivName() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    // this.loader = true;
    this.http
      .get(environment.apiUrl + "/tradingPartner/divisionName", {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        this.loader = false
        const result = JSON.parse(data).map(item => ({ label: item, value: item }));
        this.divisionList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, "getdivisionList dataa===========");
      })
  }

  getFlowType() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    // this.loader = true;
    this.http
      .get(environment.apiUrl + "/tradingPartner/flowtype", {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        this.loader = false
        const result = JSON.parse(data).map(item => ({ label: item, value: item }));
        this.flowTypeList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, "getdivisionList dataa===========");
      })
  }


  getPartnerName() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    // this.loader = true;
    this.http
      .get(environment.apiUrl + "/tradingPartner/partners", {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        this.loader = false
        const result = JSON.parse(data).map(item => ({ label: item, value: item }));
        this.partnerList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, typeof data, "getPartnerName dataa===========");
      })
  }

  getRehlkoIsaId() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    // this.loader = true;
    this.http
      .get(environment.apiUrl + "/tradingPartner/RehlkoIsaId", {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        this.loader = false
        const result = JSON.parse(data).map(item => ({ label: item, value: item }));
        this.rehlkoIsaIdList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, typeof data, "getPartnerName dataa===========");
      })
  }
  getDeliveryType() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    // this.loader = true;
    this.http
      .get(environment.apiUrl + "/tradingPartner/delivery", {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        this.loader = false
        const result = JSON.parse(data).map(item => ({ label: item, value: item }));
        this.deliveryTypeList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, typeof data, "getPartnerName dataa===========");
      })
  }
  getRehlkoGs() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    // this.loader = true;
    this.http
      .get(environment.apiUrl + "/tradingPartner/RehlkoGs", {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        this.loader = false
        const result = JSON.parse(data).map(item => ({ label: item, value: item }));
        this.rehlkoGsList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, typeof data, "getPartnerName dataa===========");
      })
  }
  update() {

    if (this.tradingPartnerSetupForm.valid) {
      //console.log('Form data:', this.tradingPartnerSetupForm.value);
      const req = {
        tcDirection: this.tradingPartnerSetupForm.value.direction,
        tcDivisionName: this.tradingPartnerSetupForm.value.divName,
        tcStream: this.tradingPartnerSetupForm.value.stream,
        flowType: this.tradingPartnerSetupForm.value.flowType,
        tcSapId: this.tradingPartnerSetupForm.value.rehlkoSAPID,
        tcKohlerIsaId: this.tradingPartnerSetupForm.value.rehlkoISAID,
        tcKohlerGs: this.tradingPartnerSetupForm.value.rehlkoGS,
        tcPartnerName: this.tradingPartnerSetupForm.value.partnerName,
        tcPartnerIsaIdQualf: this.tradingPartnerSetupForm.value.partnerISAQualify,
        tcPartnerIsaId: this.tradingPartnerSetupForm.value.partnerISAId,
        tcPartnerGs: this.tradingPartnerSetupForm.value.partnerGS,
        // partnerST: this.tradingPartnerSetupForm.value.partnerST,
        tcGsFunctionalCode: this.tradingPartnerSetupForm.value.gsFunctionalCode,
        tcMapName: this.tradingPartnerSetupForm.value.mapName,
        tcDeliveryType: this.tradingPartnerSetupForm.value.deliveryType,
        // acceptorLookupAlias: this.tradingPartnerSetupForm.value.acceptorLookupAlias,
        tcTransactionCode: this.partnerDetails.TC_TransactionCode,
        genericRID: this.partnerDetails.GenericRID,
        id: this.partnerDetails.ID,
        
      }
      //console.log(req, "req===========");
      let headers = new HttpHeaders();
      headers = headers.append(
        "authorization",
        this.localstorage.retrieve("token")
      );
      this.http
      .post(environment.apiUrl + "/tradingPartner/update", req, {
        headers: headers,
        responseType: "text",
      })
      .subscribe((data: any) => {
        //console.log(data, typeof data, "getPartnerName dataa===========");
        if(data == "Trading partner updated successfully."){
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Trading partner updated successfully."
        });
        }
        this.tradingPartnerSetupForm.reset();
      })   
    } else {
      //console.error('Form is invalid');
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Enter all required fields",
    });
    }
  }
}
